import * as Sentry from '@sentry/browser';
import * as React from 'react';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';

import Button from './Button';
import ErrorState from './ErrorState';

type Props = {
  error: Error | null | undefined;
  invalidate?: () => void;
};

/** Page-level error, rendered in-flow inside the page shell. */
export default function PageError({ error, invalidate }: Props) {
  const dispatch = useDispatch();
  const { pathname } = useLocation();

  React.useEffect(() => {
    if (!error) return;
    Sentry.captureException(error, {
      contexts: { errorState: { surface: 'PageError', route: pathname } },
    });
    // eslint-disable-next-line no-console
    console.error(error);
  }, [error, pathname]);

  return (
    <ErrorState
      body="We couldn't load this page. Please try again, or contact support if it keeps happening."
      actions={
        <>
          {invalidate && (
            <Button label="Try again" size="small" onClick={invalidate} />
          )}
          <Button
            label="Sign out"
            variant="text"
            colorScheme="black"
            size="small"
            onClick={() => dispatch({ type: 'LOGOUT' })}
          />
        </>
      }
    />
  );
}
